import React, { Component } from 'react';
import {
  CartItem,
  DetailsContainer,
  NameRow,
  CartProductName,
  BrandRow,
  QuantityRow,
  Price,
  CartImage,
  DeleteButton,
} from './style';
import { FlexCol } from '../misc';
import RemoveIcon from '../../images/removeIcon';
import { resolveImagePath } from '../../util';
import QuantityManipulator from '../../containers/quantitymanipulator';

const Image = ({ src }) => <CartImage src={src} />;
class Item extends Component {
  constructor(props) {
    super(props);
    this.state = {
      getsDeleted: false,
    };
  }
  render() {
    const { getsDeleted } = this.state;
    const { id, articleID, brand, qty, price, onDeleteCartItem } = this.props;

    return (
      <CartItem getsDeleted={getsDeleted}>
        <Image src={resolveImagePath(articleID)} />
        <DetailsContainer>
          <NameRow>
            <FlexCol>
              <CartProductName>{articleID}</CartProductName>
              <BrandRow>{brand}</BrandRow>
            </FlexCol>
            <DeleteButton
              onClick={() => {
                this.setState({ getsDeleted: true }, () => onDeleteCartItem());
              }}
            >
              <RemoveIcon width={17} height={17} />
            </DeleteButton>
          </NameRow>
          <QuantityRow>
            <QuantityManipulator articleID={articleID} id={id} qty={qty} />
            <Price>{price}</Price>
          </QuantityRow>
        </DetailsContainer>
      </CartItem>
    );
  }
}

export default Item;



// WEBPACK FOOTER //
// ../shop_main/components/cart/cartItem.js